import styled from "@emotion/styled";
import { Minus } from "react-feather";
import { StyledPropsWithTheme } from "../../utils/globalTypes";

const MinusLogo = styled(Minus)<StyledPropsWithTheme>`
  color: ${({ theme }) => theme.palette.text.secondary};
`;

export const Styled = { MinusLogo };
